import { render } from "./SVGSave.vue?vue&type=template&id=1554c7e0"
import script from "./SVGSave.vue?vue&type=script&lang=js"
export * from "./SVGSave.vue?vue&type=script&lang=js"

import exportComponent from "/home/devops/tool_cases/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__